import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { DataService } from '../../../_helpers/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as $ from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';
import { icons } from '../../constans/icons.constans';
import { AuthService } from 'src/app/_services';
import { Menu, MenuItemRender } from 'src/app/_models';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-new-snav-menu',
  templateUrl: './new-snav-menu.component.html',
  styleUrls: ['./new-snav-menu.component.css', '../../../../assets/css/new-component-view.css', '../../../../assets/css/new-buttons-theme.css'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate(200, style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate(200, style({ opacity: 1 })),
      ]),
    ])
  ],
})
export class NewSnavMenuComponent implements OnInit, OnDestroy {

  @Input() version: string = '';
  private destroy$ = new Subject<void>();
  menuItems: MenuItemRender[];
  menuBackup: MenuItemRender[]
  icons: Record<string, Record<string, string>>;
  profile: string;
  isLoggedin: boolean;
  isReloaded: string;
  profilePicture: string;
  profileName: string;
  profileEmail: string;
  accessToken: string;

  dataAccessList: string;
  fdataAccessList: string;
  isLoading: string;

  searchTerm: string = '';
  collapsed: boolean = false;

  constructor(
    private dataService: DataService
    , private sanitizer: DomSanitizer
    , private authService: AuthService
  ) {
    this.icons = icons;
    this.menuItems = JSON.parse(localStorage.getItem("accessmenu"));
    this.collapsed = JSON.parse(localStorage.getItem("statusMenu"));
    this.menuBackup = this.menuItems;
  }

  ngOnInit() {
    $.getScript("../../assets/js/common.js", function () {
    });
    this.getProfileData();
    this.getMenuStatus();
  }

  getMenuStatus() {
    this.dataService.collapsedMenuSubject$
      .pipe(
        takeUntil(this.destroy$)
      ).subscribe(val => {
        this.collapsed = val;
      })
  }

  setCollapsedValue() {
    this.collapsed = !this.collapsed;
    this.dataService.menuStatus(this.collapsed);
  }

  toggleCollapsed() {
    this.collapsed = JSON.parse(localStorage.getItem("statusMenu"));
    if (this.collapsed) {
      this.setCollapsedValue();
    } else {
      this.menuItems.forEach(el => el.expanded = false);
      setTimeout(() => {
        this.setCollapsedValue();
      }, 300)
    }
  }

  toggleExpansion(item: MenuItemRender) {
    item.expanded = !item.expanded;
    if (this.collapsed) {
      this.toggleCollapsed();
    }
  }

  filterMenuItems(searchTerm: string, menu: MenuItemRender[]) {
    return menu.filter(item =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  filteredMenuItems() {
    this.menuItems = this.searchTerm.trim().length > 0 ? this.filterMenuItems(this.searchTerm, this.menuBackup) : this.menuBackup;
  }

  getProfileData() {
    if (this.authService.isAuthenticated()) {
      this.isLoggedin = true;
      this.accessToken = localStorage.getItem('access_token');
      this.profilePicture = localStorage.getItem('userPhoto');
      this.profileName = localStorage.getItem("customername") == null ? localStorage.getItem("username") : localStorage.getItem("customername");
      this.profileEmail = localStorage.getItem("userEmail");
      this.dataAccessList = localStorage.getItem("accessmenu");
    }
  }

  logOut() {
    sessionStorage.removeItem('isSessionNew')
    localStorage.setItem('isLoggedout', "true");
    this.authService.logout();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
